import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from 'styled-components';

interface Props {
	title: React.ReactNode;
	heightVariant?: 'medium' | 'large'; // Assuming limited variants for height
	handleClick: React.MouseEventHandler<HTMLButtonElement>;
	color?: 'primary' | 'secondary'; // Assuming limited color variants
	StartIcon?: React.ReactElement;
	styles?: any;
	disabled?: boolean;
	type?: 'button' | 'submit' | 'reset'; // Assuming standard button types
	buttonType?: 'default' | 'round'; // New prop for button type
	className?: string;
}

const StyledButton = styled(Button)<{
	heightvariant?: string;
	color?: string;
	buttontype?: string;
}>`
	font-weight: 600;
	font-size: 16px;
	line-height: 21.82px;
	gap: 10px;
	height: ${(props) => (props.heightvariant === 'medium' ? '36px' : '48px')};
	border-radius: ${(props) =>
		props.buttontype === 'round' ? '32px !important' : '4px !important'};
	box-shadow: ${(props) =>
		props.buttontype === 'round' ? '0px 0px 14px 0px rgba(0, 0, 0, 0.14)' : 'none'};

	&:hover {
		background-color: ${(props) => (props.color === 'primary' ? '#FFC51A' : '#F4F2F0')};
	}
`;

const CustomButton: React.FC<Props> = ({
	title,
	handleClick,
	color = 'primary',
	StartIcon,
	styles,
	heightVariant = 'medium',
	disabled = false,
	type = 'button',
	buttonType = 'default', // Default to 'default' if not specified
	...rest
}: Props) => {
	return (
		<StyledButton
			variant="contained"
			heightvariant={heightVariant}
			sx={styles}
			onClick={handleClick}
			color={color}
			disabled={disabled}
			type={type}
			buttontype={buttonType}
			{...rest}
		>
			{StartIcon && <span>{StartIcon}</span>}
			{title}
		</StyledButton>
	);
};

export default CustomButton;
